"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorTypes = exports.trackingTypes = exports.consumers = exports.priceDescr = exports.actionProduct = exports.productGroup = exports.travelDestination = exports.criteriaKeys = void 0;
var criteriaKeys;
(function (criteriaKeys) {
    criteriaKeys["milage"] = "milage";
    criteriaKeys["destination"] = "destination";
    criteriaKeys["mostExpensiveItemPrice"] = "mostExpensiveItemPrice";
    criteriaKeys["specialContentPrice"] = "specialContentPrice";
})(criteriaKeys || (criteriaKeys = {}));
exports.criteriaKeys = criteriaKeys;
var consumers;
(function (consumers) {
    consumers["console"] = "console";
    consumers["ga"] = "ga";
    consumers["sas360"] = "sas360";
    consumers["kibana"] = "kibana";
    consumers["fb"] = "fb";
})(consumers || (consumers = {}));
exports.consumers = consumers;
var trackingTypes;
(function (trackingTypes) {
    trackingTypes["behaviour"] = "behaviour";
    trackingTypes["technical"] = "technical";
    trackingTypes["ecommerce"] = "ecommerce";
})(trackingTypes || (trackingTypes = {}));
exports.trackingTypes = trackingTypes;
// is the error technical or caused by the user (ex. form validation)
var errorTypes;
(function (errorTypes) {
    errorTypes["user"] = "user";
    errorTypes["tech"] = "tech";
    errorTypes["rule"] = "rule";
})(errorTypes || (errorTypes = {}));
exports.errorTypes = errorTypes;
// ecommerce
var travelDestination;
(function (travelDestination) {
    travelDestination["europe"] = "Europe";
    travelDestination["world"] = "World";
})(travelDestination || (travelDestination = {}));
exports.travelDestination = travelDestination;
var priceDescr;
(function (priceDescr) {
    priceDescr["once"] = "oneTimePayment";
    priceDescr["monthly"] = "monthly";
    priceDescr["yearly"] = "yearly";
})(priceDescr || (priceDescr = {}));
exports.priceDescr = priceDescr;
var productGroup;
(function (productGroup) {
    productGroup["insurance"] = "forsikring";
})(productGroup || (productGroup = {}));
exports.productGroup = productGroup;
var actionCart;
(function (actionCart) {
    // view = 'cartview',
    actionCart["checkout"] = "checkout";
    actionCart["purchase"] = "purchase";
})(actionCart || (actionCart = {}));
var actionProduct;
(function (actionProduct) {
    actionProduct["add"] = "add";
    actionProduct["update"] = "update";
    actionProduct["delete"] = "delete";
})(actionProduct || (actionProduct = {}));
exports.actionProduct = actionProduct;
